import verticalCardData from './wireframeComponentBlockData/verticalCard.json';
import horizontalCardData from './wireframeComponentBlockData/horizontalCard.json';
import userCardData from './wireframeComponentBlockData/userCard.json';
import modalData from './wireframeComponentBlockData/modal.json';
import loginData from './wireframeComponentBlockData/login.json';
import signUpData from './wireframeComponentBlockData/signUp.json';
import notificationBannerData from './wireframeComponentBlockData/notificationBanner.json';
import successBannerData from './wireframeComponentBlockData/successBanner.json';
import warningBannerData from './wireframeComponentBlockData/warningBanner.json';
import infoBannerData from './wireframeComponentBlockData/infoBanner.json';
import errorBannerData from './wireframeComponentBlockData/errorBanner.json';
import dateRangeData from './wireframeComponentBlockData/dateRange.json';
import calendarData from './wireframeComponentBlockData/calendar.json';
import settingsFormData from './wireframeComponentBlockData/settingsForm.json';
import contactDetailsFormData from './wireframeComponentBlockData/contactDetailsForm.json';
import contactUsFormData from './wireframeComponentBlockData/contactUsForm.json';
import errorDialogData from './wireframeComponentBlockData/errorDialog.json';
import searchAndFilterData from './wireframeComponentBlockData/searchAndFilter.json';
import searchFieldData from './wireframeComponentBlockData/searchField.json';
import warningDialogData from './wireframeComponentBlockData/warningDialog.json';
import dataTableData from './wireframeComponentBlockData/dataTable.json';
import wizardData from './wireframeComponentBlockData/wizard.json';
import shareSheetData from './wireframeComponentBlockData/shareSheet.json';
import videoModalData from './wireframeComponentBlockData/videoModal.json';
import imageModalData from './wireframeComponentBlockData/imageModal.json';
import fileUploadData from './wireframeComponentBlockData/fileUpload.json';
import tooltipData from './wireframeComponentBlockData/tooltip.json';
import paymentFormData from './wireframeComponentBlockData/paymentForm.json';
import playbackControlsData from './wireframeComponentBlockData/playbackControls.json';
import mapInputData from './wireframeComponentBlockData/mapInput.json';
import productCardData from './wireframeComponentBlockData/prodcutCard.json';
import dashboardCardData from './wireframeComponentBlockData/dashboardCard.json';
import dashboardGraphData from './wireframeComponentBlockData/dashboardGraph.json';
import upgradeCardData from './wireframeComponentBlockData/upgradeCard.json';
import imageCarouselData from './wireframeComponentBlockData/imageCarousel.json';
import imageGalleryData from './wireframeComponentBlockData/imageGallery.json';

import verticalCardImage from '../assets/wireframes/componentBlocks/verticalCard.png';
import horizontalCardImage from '../assets/wireframes/componentBlocks/horizontalCard.png';
import userCardImage from '../assets/wireframes/componentBlocks/userCard.png';
import modalImage from '../assets/wireframes/componentBlocks/modal.png';
import loginImage from '../assets/wireframes/componentBlocks/login.png';
import signUpImage from '../assets/wireframes/componentBlocks/signUp.png';
import notificationBannerImage from '../assets/wireframes/componentBlocks/notificationBanner.png';
import successBannerImage from '../assets/wireframes/componentBlocks/successBanner.png';
import warningBannerImage from '../assets/wireframes/componentBlocks/warningBanner.png';
import infoBannerImage from '../assets/wireframes/componentBlocks/infoBanner.png';
import errorBannerImage from '../assets/wireframes/componentBlocks/errorBanner.png';
import dateRangeImage from '../assets/wireframes/componentBlocks/dateRange.png';
import calendarImage from '../assets/wireframes/componentBlocks/calendar.png';
import settingsFormImage from '../assets/wireframes/componentBlocks/settingsForm.png';
import contactDetailsFormImage from '../assets/wireframes/componentBlocks/contactDetailsForm.png';
import contactUsFormImage from '../assets/wireframes/componentBlocks/contactUsForm.png';
import errorDialogImage from '../assets/wireframes/componentBlocks/errorDialog.png';
import searchAndFilterImage from '../assets/wireframes/componentBlocks/searchAndFilter.png';
import searchFieldImage from '../assets/wireframes/componentBlocks/searchField.png';
import warningDialogImage from '../assets/wireframes/componentBlocks/warningDialog.png';
import dataTableImage from '../assets/wireframes/componentBlocks/dataTable.png';
import wizardImage from '../assets/wireframes/componentBlocks/wizard.png';
import shareSheetImage from '../assets/wireframes/componentBlocks/shareSheet.png';
import videoModalImage from '../assets/wireframes/componentBlocks/videoModal.png';
import imageModalImage from '../assets/wireframes/componentBlocks/imageModal.png';
import fileUploadImage from '../assets/wireframes/componentBlocks/fileUpload.png';
import tooltipImage from '../assets/wireframes/componentBlocks/tooltip.png';
import paymentFormImage from '../assets/wireframes/componentBlocks/paymentForm.png';
import playbackControlsImage from '../assets/wireframes/componentBlocks/playbackControls.png';
import mapInputImage from '../assets/wireframes/componentBlocks/mapInput.png';
import productCardImage from '../assets/wireframes/componentBlocks/productCard.png';
import dashboardCardImage from '../assets/wireframes/componentBlocks/dashboardCard.png';
import dashboardGraphImage from '../assets/wireframes/componentBlocks/dashboardGraph.png';
import upgradeCardImage from '../assets/wireframes/componentBlocks/upgradeCard.png';
import imageCarouselImage from '../assets/wireframes/componentBlocks/imageCarousel.png';
import imageGalleryImage from '../assets/wireframes/componentBlocks/imageGallery.png';

/* Instructions for adding a new wireframe component block:
1. Select the content from the source whiteboard and copy it to the clipboard
2. Create a new file alongside the rest of the .json data files
3. Paste the JSON from the clipboard into the new file. Delete the top-level `whiteboardId` field.
4. Import the JSON and create a new object in this file that references it. Set `iconData` to `null` to enable thumbnail generation.
5. Export the new object and add its name to the list of blocks in `StylusBlock.tsx`
6. Load/refresh the dev whiteboard app. This should trigger a download of the full-size PNG thumbnail for the block.
7. `brew install` these packages: `oxipng` and `imagemagick`. Oxipng is a PNG compressor, and ImageMagick will resize the compressed file
8. Run `magick filename.png -resize 90 filename-small.png` to resize the file to 90x wide
9. Run `oxipng -s -o 6 filename.png` to compress the PNG and strip any unneeded metadata
10. Copy `filename-small.png` to where the rest of the PNGs are and add an import for it.
11. Change `iconData` of your new block from `null` to the PNG import you just added
12. Refresh the whiteboard and check the thumbnail looks right.
 */

export interface WireframeComponentBlock {
  shapeData: {
    version: string;
    whiteboardId?: never; // Make sure `whiteboardId` has been removed
    objects: Record<string, any>;
  };
  /** When set to `null` the block will be rendered at runtime and the image downloaded to your computer */
  iconData: string | null;
  displayName: string;
}

const wizard: WireframeComponentBlock = {
  shapeData: wizardData,
  displayName: 'Wizard',
  iconData: wizardImage,
};

const dataTable: WireframeComponentBlock = {
  shapeData: dataTableData,
  displayName: 'Data table',
  iconData: dataTableImage,
};

const contactDetailsForm: WireframeComponentBlock = {
  shapeData: contactDetailsFormData,
  displayName: 'Contact details',
  iconData: contactDetailsFormImage,
};

const contactUsForm: WireframeComponentBlock = {
  shapeData: contactUsFormData,
  displayName: 'Contact us form',
  iconData: contactUsFormImage,
};

const errorDialog: WireframeComponentBlock = {
  shapeData: errorDialogData,
  displayName: 'Error dialog',
  iconData: errorDialogImage,
};

const warningDialog: WireframeComponentBlock = {
  shapeData: warningDialogData,
  displayName: 'Warning dialog',
  iconData: warningDialogImage,
};

const searchAndFilter: WireframeComponentBlock = {
  shapeData: searchAndFilterData,
  displayName: 'Search and filter',
  iconData: searchAndFilterImage,
};

const searchField: WireframeComponentBlock = {
  shapeData: searchFieldData,
  displayName: 'Search field',
  iconData: searchFieldImage,
};

const verticalCard: WireframeComponentBlock = {
  shapeData: verticalCardData,
  displayName: 'Vertical card',
  iconData: verticalCardImage,
};

const horizontalCard: WireframeComponentBlock = {
  shapeData: horizontalCardData,
  displayName: 'Horizontal card',
  iconData: horizontalCardImage,
};

const userCard: WireframeComponentBlock = {
  shapeData: userCardData,
  displayName: 'User card',
  iconData: userCardImage,
};

const modal: WireframeComponentBlock = {
  shapeData: modalData,
  displayName: 'Modal',
  iconData: modalImage,
};

const login: WireframeComponentBlock = {
  shapeData: loginData,
  displayName: 'Login',
  iconData: loginImage,
};

const signUp: WireframeComponentBlock = {
  shapeData: signUpData,
  displayName: 'Sign up',
  iconData: signUpImage,
};

const notificationBanner: WireframeComponentBlock = {
  shapeData: notificationBannerData,
  displayName: 'Notification banner',
  iconData: notificationBannerImage,
};

const successBanner: WireframeComponentBlock = {
  shapeData: successBannerData,
  displayName: 'Success banner',
  iconData: successBannerImage,
};

const warningBanner: WireframeComponentBlock = {
  shapeData: warningBannerData,
  displayName: 'Warning banner',
  iconData: warningBannerImage,
};

const infoBanner: WireframeComponentBlock = {
  shapeData: infoBannerData,
  displayName: 'Info banner',
  iconData: infoBannerImage,
};

const errorBanner: WireframeComponentBlock = {
  shapeData: errorBannerData,
  displayName: 'Error banner',
  iconData: errorBannerImage,
};

const dateRange: WireframeComponentBlock = {
  shapeData: dateRangeData,
  displayName: 'Date range',
  iconData: dateRangeImage,
};

const calendar: WireframeComponentBlock = {
  shapeData: calendarData,
  displayName: 'Calendar',
  iconData: calendarImage,
};

const settingsForm: WireframeComponentBlock = {
  shapeData: settingsFormData,
  displayName: 'Settings form',
  iconData: settingsFormImage,
};

const shareSheet: WireframeComponentBlock = {
  shapeData: shareSheetData,
  displayName: 'Share sheet',
  iconData: shareSheetImage,
};

const videoModal: WireframeComponentBlock = {
  shapeData: videoModalData,
  displayName: 'Video modal',
  iconData: videoModalImage,
};

const imageModal: WireframeComponentBlock = {
  shapeData: imageModalData,
  displayName: 'Image modal',
  iconData: imageModalImage,
};

const fileUpload: WireframeComponentBlock = {
  shapeData: fileUploadData,
  displayName: 'File upload',
  iconData: fileUploadImage,
};

const tooltip: WireframeComponentBlock = {
  shapeData: tooltipData,
  displayName: 'Tooltip',
  iconData: tooltipImage,
};

const paymentForm: WireframeComponentBlock = {
  shapeData: paymentFormData,
  displayName: 'Payment form',
  iconData: paymentFormImage,
};

const playbackControls: WireframeComponentBlock = {
  shapeData: playbackControlsData,
  displayName: 'Playback controls',
  iconData: playbackControlsImage,
};

const mapInput: WireframeComponentBlock = {
  shapeData: mapInputData,
  displayName: 'Map input',
  iconData: mapInputImage,
};

const productCard: WireframeComponentBlock = {
  shapeData: productCardData,
  displayName: 'Product card',
  iconData: productCardImage,
};

const dashboardCard: WireframeComponentBlock = {
  shapeData: dashboardCardData,
  displayName: 'Dashboard card',
  iconData: dashboardCardImage,
};

const dashboardGraph: WireframeComponentBlock = {
  shapeData: dashboardGraphData,
  displayName: 'Dashboard graph',
  iconData: dashboardGraphImage,
};

const upgradeCard: WireframeComponentBlock = {
  shapeData: upgradeCardData,
  displayName: 'Upgrade card',
  iconData: upgradeCardImage,
};

const imageCarousel: WireframeComponentBlock = {
  shapeData: imageCarouselData,
  displayName: 'Image carousel',
  iconData: imageCarouselImage,
};

const imageGallery: WireframeComponentBlock = {
  shapeData: imageGalleryData,
  displayName: 'Image gallery',
  iconData: imageGalleryImage,
};

const componentBlocks = {
  verticalCard,
  horizontalCard,
  userCard,
  modal,
  login,
  signUp,
  notificationBanner,
  successBanner,
  warningBanner,
  infoBanner,
  errorBanner,
  dateRange,
  calendar,
  settingsForm,
  contactDetailsForm,
  contactUsForm,
  errorDialog,
  warningDialog,
  searchAndFilter,
  searchField,
  dataTable,
  wizard,
  shareSheet,
  videoModal,
  imageModal,
  fileUpload,
  tooltip,
  paymentForm,
  playbackControls,
  mapInput,
  productCard,
  dashboardCard,
  dashboardGraph,
  upgradeCard,
  imageCarousel,
  imageGallery,
};
export type WireframeComponentBlockNames = keyof typeof componentBlocks;
export default componentBlocks;
